// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mylZp","title":"styles_title__206GE"};